import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'b965c140-1762-4d2f-bccb-bf4ded87ffb6',
    countryCodes: ['LT'],
    locale: 'lt-LT',
    enable: {
        prelaunch: false,
    },
});
